import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import AddPublication from "./AddPublication";
import {
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";

function PublicationTable(props) {
  const columns = [
    {
      title: "Publication Name",
      dataIndex: "publicationName",
      //sorter: true,
      width: 350,
    },
    {
      title: "Creditor",
      dataIndex: "accountName",
      width: 300,
    },
    {
      title: "Creditor for Classifieds",
      dataIndex: "classifiedAccountName",
      width: 300,
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    "/config/publication",
    null,
    API_METHODS.GET
  );
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [tableData, setTableData] = useState();
  const [selectedRecord, setSelectedRecord] = useState();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
  }, [responseData]);

  const handleAddPublication = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
      props.refreshClientConfig();
    }
  };

  const handleEditPublication = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
      props.refreshClientConfig();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(replaceBlankValueToUndefined(record));
  };

  const onSearch = (publicationName) => {
    if (!isEmpty(publicationName)) {
      let searched_records = tableData.filter((record) =>
        record.publicationName
          .toLowerCase()
          .includes(publicationName.toLowerCase())
      );
      setTableData(searched_records);
    } else {
      getRequest();
    }
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Publications</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="Publication Name"
              allowClear
              enterButton="Search"
              onSearch={onSearch}
            />
            <Button type="primary" onClick={handleAddPublication}>
              Add Publication
            </Button>
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        clientSideRender={true}
      />
      {visible && (
        <AddPublication visible={visible} close={handleAddPublication} />
      )}
      {visibleEdit && (
        <AddPublication
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditPublication}
        />
      )}
    </>
  );
}

export default PublicationTable;
